export default __webpack_public_path__ + "static/media/smiling-face-with-hearts.28a761ff.png";